<script>
import SeminarCard from "@/components/HomePageView/SeminarCard.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import {usePriceItemStore} from "@/store/price-items";
import {computed} from "vue";
import environment from "@/environment";

export default {
name: "SeminarList",
  components: {ActionButton, SeminarCard},
  setup() {
    const priceItemStore = usePriceItemStore()

    const topItems = computed(() => {
      const categories = priceItemStore.items.filter(
          category => category.category_id === environment.appConfig.seminarCategory

      )
      return categories
          .flatMap(category => category.price_list_items) //беру вложенные price_list_items
          .sort(() => Math.random() - 0.5)
          .slice(0, 2); // Беру верхние 5
    });

    return {topItems}
  }
}
</script>

<template>
   <div class="seminarList" v-if="topItems?.length > 0">
      <span class="seminarList__header">СЕМИНАРЫ</span>
      <SeminarCard
          v-for="item in topItems"
          :key="item.id"
          :item="item"
      >
        <div style="color: white">{{item.name}}</div>
        <div>{{ item.production_date }}</div>
        <div>
          <ActionButton>
            <template #caption>О технологии</template>
          </ActionButton>
        </div>
      </SeminarCard>
   </div>
</template>

<style scoped lang="scss">
.seminarList {
  text-align: left;
  display: inline-flex;
  flex-direction: column;
  width: 349px;
  max-width: 100%;
  gap: 20px;

  @include respond-to('lg') { width: 100%; }

  &__header {
    color: var(--cd-text-muted);
  }
}
</style>
